import axiosInstance from "../service/axiosInterceptor";

// Get all Time Doctor users (dashboard)
export async function getAllTimeDoctorUsers() {
  const response = await axiosInstance.get("/api/time-doctor/users");
  return response.data; // Array of users
}

// Get single Time Doctor user (detail/report)
export async function getSingleTimeDoctorUser(userId) {
  const response = await axiosInstance.get(`/api/time-doctor/user/${userId}`);
  console.log(response.data, "usrDetail1")
  return response.data; // Full user object
}

// Get screenshots for a user
export async function getScreenshots(userId, from, to) {
  const response = await axiosInstance.get("/api/time-doctor/screenshots", {
    params: { userId, from, to }
  });
  return response.data; // Array of screenshots
}

// Get activity timeline for a user
export async function getActivity(userId, from, to) {
  const response = await axiosInstance.get("/api/time-doctor/activity", {
    params: { userId, from, to }
  });
  return response.data; // Array of activities
}

// Get productivity/time use for a user
export async function getTimeUse(userId, from, to) {
  const response = await axiosInstance.get("/api/time-doctor/timeuse", {
    params: { userId, from, to }
  });
  return response.data; // Productivity/time use object
}

// Get all projects (cached 5 min)
export async function getProjects() {
  const response = await axiosInstance.get("/api/time-doctor/projects");
  return response.data; // Array of projects
}

// Get all tasks (cached 5 min)
export async function getTasks() {
  const response = await axiosInstance.get("/api/time-doctor/tasks");
  return response.data; // Array of tasks
}

// Get client's assigned billers with Time Doctor mapping
export async function getClientAssignedBillers() {
  const response = await axiosInstance.get("/api/time-doctor/client/billers");
  return response.data.billers || [];
}

// Create or update a mapping between a biller and a Time Doctor user
export async function createOrUpdateMapping({ userId, timeDoctorUserId, timeDoctorEmail, companyId }) {
  const response = await axiosInstance.post('/api/time-doctor/mapping', {
    userId,
    timeDoctorUserId,
    timeDoctorEmail,
    companyId
  });
  return response.data;
}

// Delete a mapping
export async function deleteMapping(userId) {
  const response = await axiosInstance.delete(`/api/time-doctor/mapping/${userId}`);
  return response.data;
}

// Get all mappings (admin only)
export async function getAllMappings() {
  const response = await axiosInstance.get('/api/time-doctor/mappings');
  return response.data.mappings;
}